export const Notesemail = ({
  secondaryColor = "#3b4046",

  primaryFontColor = "rgb(255, 255, 255)",
  width = "69",
  height = "69",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26.201 26.201"
    >
      <path
        id="email"
        d="M13.1,26.2A13.1,13.1,0,1,1,26.2,13.1,13.115,13.115,0,0,1,13.1,26.2Zm6.794-8.5a.293.293,0,0,0,.293-.293V9.185l-6.665,5.293a.678.678,0,0,1-.843,0L6.014,9.185V17.41a.293.293,0,0,0,.293.293ZM18.873,8.5,13.1,13.082,7.328,8.5Zm2.67.293V17.41a1.65,1.65,0,0,1-1.648,1.648H6.307A1.65,1.65,0,0,1,4.659,17.41V8.791A1.65,1.65,0,0,1,6.307,7.143H19.894A1.65,1.65,0,0,1,21.543,8.791Z"
        fill={secondaryColor}
        fill-rule="evenodd"
      />
    </svg>
  );
};
